import type { TFunction } from 'i18next';

export interface OnboardingPreferences {
  language: string;
  timezone: string;
  defaultCurrency: string;
}

const CURRENCIES = ['BRL', 'USD', 'EUR', 'GBP', 'CAD', 'AUD', 'BTC', 'ETH'];
const LANGUAGES = ['pt', 'en', 'es'];
const TIMEZONES = [
  'America/Sao_Paulo',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'Europe/London',
  'Europe/Paris',
  'Asia/Tokyo',
  'Australia/Sydney',
  'UTC',
];

type Option = { value: string; label: string };

export const currencyOptions = (t: TFunction): Option[] =>
  CURRENCIES.map((value) => ({ value, label: t(`currencies.${value}`) }));

export const languageOptions = (t: TFunction): Option[] =>
  LANGUAGES.map((value) => ({ value, label: t(`languages.${value}`) }));

/** The usual zones, plus the one the browser reports when it isn't among them. */
export const timezoneOptions = (t: TFunction, current?: string): Option[] => {
  const zones = current && !TIMEZONES.includes(current) ? [current, ...TIMEZONES] : TIMEZONES;
  return zones.map((value) => ({ value, label: t(`timezones.${value}`, { defaultValue: value.replace(/_/g, ' ') }) }));
};
